import React, { FC, useContext, useMemo } from 'react';
import { IBasicUserInfo } from '../resources/models/IUserInfo';
import { UserContext } from './UserContext';
import { CurrentUserContext } from './CurrentUserContext';
import { OrganizationUserFetcher } from '../fetchers/OrganizationUserFetcher';

interface IProps {
  user: IBasicUserInfo;
}

export const UserContextProvider: FC<IProps> = ({ children, user }) => {
  const contextValue = useMemo(
    () => ({
      user: user,
      userId: user.id,
    }),
    [user]
  );

  return <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>;
};

export const UserContextFromCurrentUserProvider: FC = ({ children }) => {
  const { userInfo } = useContext(CurrentUserContext);
  const contextValue = useMemo(
    () => ({
      user: userInfo,
      userId: userInfo?.id ?? null,
    }),
    [userInfo]
  );
  return <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>;
};

export const UserContextFromOrganizationUserProvider: FC = ({ children }) => {
  const { data } = useContext(OrganizationUserFetcher.Context);
  const contextValue = useMemo(
    () => ({
      user: data?.payload ?? null,
      userId: data?.payload.id ?? null,
    }),
    [data?.payload]
  );
  return <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>;
};
